import React, { useEffect } from 'react';
import * as dateFns from 'date-fns';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';

import Filters from './Filters';
import Table, { RowType } from '../../../Shared/CustomTable';
import { fixDecimals, saveDataEventsOnLocalStorage, text_truncate } from '../../../../helpers/helpers';
import Loader from '../../../Shared/Loader';

import './Practices.scss';
import { useRouter } from '../../../../helpers/customHooks';
import { useDataPlayersDispatch, useDataPlayersState, useFiltersState } from '../../../../store/hooks';
import { FILTER_GLOBAL_KEYS, FILTER_KEYS, MESSAGES } from '../../../../config/constants';
import { PlayerRoutes } from '../../types';
import { DataPlayer } from '../../../../store/types';

const Practices =  () => {

  const { location, match, specificScope } = useRouter<PlayerRoutes>();
  const { dataPlayer, playerPractices = [] } = useDataPlayersState(match.params.playerId);
  const {
    [FILTER_GLOBAL_KEYS.WEEKS]: weeks,
    [FILTER_KEYS.DATE_RANGE]: filterDateRangeData
  } = useFiltersState(specificScope, FILTER_GLOBAL_KEYS.WEEKS, FILTER_KEYS.DATE_RANGE);
  const { getPlayerMetrics } = useDataPlayersDispatch();

  useEffect(() => {
    if (weeks && filterDateRangeData && filterDateRangeData.selectedDates && filterDateRangeData.selectedDates.length) {
      getPlayerMetrics();
    }
  }, [weeks, filterDateRangeData]);

  useEffect(() => {
    saveDataEventsOnLocalStorage(playerPractices.map(practice => practice.gameId));
  }, [playerPractices]);

  const headers = [
    // {
    //   content: (<><input className="styled-checkbox" id="styled-checkbox-head" type="checkbox" value="value1"/>
    //     <label htmlFor="styled-checkbox-head" className="check-l"/></>),
    //   class: 'oo-i'
    // },
    { content: 'NAME', style: { width: '338px', paddingLeft: '20px' }, isOrderly: true },
    { content: 'DATE/TIME', style: { width: '154px' }, isOrderly: true },
    { content: 'INTENSITY', style: { width: '77px' }, isOrderly: true },
    { content: 'MAX SPEED', style: { width: '89px' }, class: 'll-pp', isOrderly: true },
    { content: 'MAX SUST. SPEED', style: { width: '102px' }, class: 'll-pp', isOrderly: true },
    { content: 'TTL. DIST.', style: { width: '76px' }, class: 'll-pp', isOrderly: true },
    // { content: 'TTL. HARD EFF. DIST.', style: { width: '82px' }, class: 'll-pp', isOrderly: true },
    { content: 'TTL. ACCEL CT.', style: { width: '51px' }, class: 'll-pp', isOrderly: true },
    { content: 'TTL. DECEL CT.', style: { width: '51px' }, class: 'll-pp', isOrderly: true },
    { content: '', style: { width: '334px' } }
  ];
  let rows: RowType[] = [];
  if (playerPractices) {
    rows = playerPractices.map((practice, index) => {
      const practicePath = dataPlayer && dataPlayer.meta && dataPlayer.meta.playerId ? `/view/practice/${practice.gameId}/performance/expanded/modal/${dataPlayer.meta.playerId}`
        : `/view/practice/${practice.gameId}/performance/expanded/page`;
      return ({
        columns: [
          // {
          //   content: (<><label className="l-c">
          //     <input className="styled-checkbox" id={`styled-checkbox-${practice.gameId}`} type="checkbox"
          //            value="value2"/>
          //     <label htmlFor={`styled-checkbox-${practice.gameId}`} className="check-l"/>
          //   </label></>), class: 'oo-i'
          // },
          {
            content: { name: practice.name },
            print: (content) =>
              <Link
                to={{
                  pathname: practicePath,
                  state: {
                    toReturn: location.pathname,
                    toReturnSearch: location.search
                  }
                }}
              >
                <label
                  title={content.name} className="l-c" style={{ cursor: 'pointer' }}
                ><b> {text_truncate(content.name, 40)}</b></label>
              </Link>,
            order: (contentA, contentB) => contentA.name.localeCompare(contentB.name),
            style: { cursor: 'pointer', paddingLeft: '20px' }
          },
          {
            content: { startTime: practice.startTime},// style: {width: '12%'}
            print: (content) => <label
              className="l-c"
            >{content.startTime ? dateFns.format(new Date(content.startTime), 'MM/dd/yyyy, hh:mma') : '--'}</label>,
            order: (contentA, contentB) => contentA.startTime - contentB.startTime
          },
          {
            content: { intensity: practice.intensity },
            print: (content) => <label className="l-c">{text_truncate(content.intensity,12)}</label>,
            order: (contentA, contentB) => contentA.intensity.localeCompare(contentB.intensity)
          },
          {
            content: { maxSpeed: practice.maxSpeed },
            print: (content) => <label className="l-c">{fixDecimals(content.maxSpeed, 1)}</label>,
            order: (contentA, contentB) => contentA.maxSpeed - contentB.maxSpeed,
            class: 'll-pp'
          },
          {
            content: { maxSustainedSpeed: practice.maxSustainedSpeed },
            print: (content) => <label className="l-c">{fixDecimals(content.maxSustainedSpeed, 1)}</label>,
            order: (contentA, contentB) => contentA.maxSustainedSpeed - contentB.maxSustainedSpeed,
            class: 'll-pp'
          },
          {
            content: { totalDis: practice.totalDis },
            print: (content) => <label className="l-c">{fixDecimals(content.totalDis, 0)}</label>,
            order: (contentA, contentB) => contentA.totalDis - contentB.totalDis,
            class: 'll-pp'
          },
          // {
          //   content: { teamHardEffortDist: practice.teamHardEffortDist },
          //   print: (content) => <label className="l-c">{fixDecimals(content.teamHardEffortDist, 0)}</label>,
          //   order: (contentA, contentB) => contentA.teamHardEffortDist - contentB.teamHardEffortDist,
          //   class: 'll-pp'
          // },
          {
            content: { accels: fixDecimals(practice.accelFast + practice.accelMed + practice.accelSlow, 0) },
            print: (content) => <label className="l-c">{content.accels}</label>,
            order: (contentA, contentB) => contentA.accels - contentB.accels,
            class: 'll-pp'
          },
          {
            content: { decels: fixDecimals(practice.deccelFast + practice.deccelMed + practice.deccelSlow, 0) },
            print: (content) => <label className="l-c">{content.decels}</label>,
            order: (contentA, contentB) => contentA.decels - contentB.decels,
            class: 'll-pp'
          },
          {
            content: (<>{/*<Button>Export <i className="mdi mdi-menu-down" /></Button>*/}
              <Link
                to={{
                  pathname: practicePath,
                  state: {
                    toReturn: location.pathname,
                    toReturnSearch: location.search
                  }
                }}
              >
                <Button className="btn-blue"> View Full Practice Data</Button>
              </Link></>), class: 'oo-u'
          }
        ],
        id: `${practice.gameId}-${index}`
      });
    });
  }
  return (<>
    <Filters player={(dataPlayer as DataPlayer).meta} />
    <div className="performance-body player-01">
      <Loader forceLoader={!weeks}>
      {playerPractices && playerPractices.length === 0 ? 
      <Loader forceMessage={ MESSAGES.EMPTY }/>
       : 
        <Table
          headers={headers}
          rows={rows}
          default={{ orderColumn: 2 }}
        />
        }
      </Loader>
    </div>
  </>);
};

export default Practices;
